import { ITncRepository } from '../../ports/ITncRepository';
import { TncCase, SignatureData } from '../../domain/entities';

export class SubmitSignaturesUseCase {
  constructor(private readonly tncRepository: ITncRepository) {}

  async execute(
    caseId: string,
    employeeSignature: SignatureData,
    employerSignature: SignatureData,
    declined?: boolean
  ): Promise<TncCase> {
    return this.tncRepository.submitSignatures(caseId, employeeSignature, employerSignature, declined);
  }
}
